// eslint-disable-next-line import/prefer-default-export
export const SET_TRANSCRIPT_METADATA = 'SET_TRANSCRIPT_METADATA';
